import { useParams } from "react-router-dom";
// import projectsJSON from "../../assets/data/projects.json";
import { useState, useEffect } from "react";
import axios from "axios";
const Show = () => {
	const [project, setProject] = useState(null);

	const { slug } = useParams();
	useEffect(() => {
		axios
			.get(
				`https://agne-portfolio-default-rtdb.europe-west1.firebasedatabase.app/.json`
			)
			.then((response) => {
				setProject(response.data.find((project) => project.slug === slug));
			})
			.catch((e) => {
				console.error(e);
			});
	}, []);

	if (!project) {
		return (
			<div class="grid grid-cols-1">
				<span className="loading loading-spinner loading-lg place-self-center"></span>
			</div>
		);
	}

	let imgs = "";
	if (project.images) {
		let items = project.images.map((image, i) => {
			return (
				<div id={`#item${i}`} className="carousel-item w-full">
					<img
						src={`${image.path}`}
						alt={`${image.caption}`}
						className="w-full"
					/>
				</div>
			);
		});
		let buttons = project.images.map((image, i) => {
			return (
				<a href={`#item${i}`} className="btn btn-xs">
					{i + 1}
				</a>
			);
		});
		imgs = (
			<>
				<div className="my-5">
					<div className="carousel">{items}</div>
					<div className="flex justify-center py-2 gap-2">{buttons}</div>
				</div>
			</>
		);
	}

	const tags = project.tags.map((tag, i) => {
		return (
			<div key={i} className="badge badge-outline badge-accent badge-lg">
				{tag}
			</div>
		);
	});

	let figmaMiro = "";
	if (!project.figma ? project.miro : project.figma) {
		figmaMiro = (
			<>
				<iframe
					style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
					width="550"
					height="400"
					src={!project.figma ? project.miro : project.figma}
					frameborder="0"
					scrolling="no"
					allow="fullscreen; clipboard-read; clipboard-write"
					allowfullscreen
				></iframe>
			</>
		);
	}
	return (
		<>
			<div>
				<div className="p-5 ">
					<h1 className="text-4xl text-center font-mono">{project.title}</h1>
				</div>
				<div className=" flex space-x-4  justify-center mb-3">{tags}</div>
			</div>
			<div className="flex justify-around pt-5">
				<div>
					<span>
						<b>Year:</b> {project.date}
					</span>
					<p className="w-96 py-5 text-base/loose">{project.description}</p>
					{/* <div>{imgs}</div> */}
					{/* {project.demo ? <p>demo goes here</p> : ""} */}
				</div>
				<div>
					<div>{figmaMiro}</div>
					<p>
						<kbd className="kbd kbd-sm">Click</kbd> +{" "}
						<kbd className="kbd kbd-sm">hold</kbd> = move around,{" "}
						<kbd className="kbd kbd-sm">ctrl</kbd>+
						<kbd className="kbd kbd-sm">scroll</kbd>= zoom
					</p>
					<div className="divider"></div>

					<div className="flex">
						<b>github: </b>{" "}
						{!project.github ? (
							<div>Sorry, this project does not have a github Repo</div>
						) : (
							<a href={project.github} target="_blank" rel="noreferrer">
								{project.github}
							</a>
						)}
					</div>
					<div className="flex">
						<b>website: </b>
						{!project.website ? (
							<div>Sorry, this project is not hosted</div>
						) : (
							<a href={project.website} target="_blank" rel="noreferrer">
								{project.website}
							</a>
						)}
					</div>
				</div>
			</div>
		</>
	);
};
export default Show;
